import * as React from 'react';
import { Link } from 'react-router-dom';
import { ClickTracker } from 'bernie-analytics';
import { AnalyticsStore } from 'bernie-core';
import { UitkCarousel } from 'uitk-react-carousel';
import { UitkCard, UitkCardContent, UitkCardImageLayout, UitkCardLink, UitkCardMedia, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { LocalizedComponentClass, LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { CarouselModel } from 'models';
import { inject } from 'mobx-react';

const LinkTracked = ClickTracker(Link);

interface PropertyTypeCarouselProps extends LocalizedComponentProps {
  model: CarouselModel;
  analytics?: AnalyticsStore;
}

interface PropertyTypeCarouselPropsWithClassName extends PropertyTypeCarouselProps {
  className: string;
}

const propertyTypeCarousel = withLocalization((props: PropertyTypeCarouselProps) => {
  const { l10n, model, analytics } = props;
  const carouselProps = {
    pageBy: 1,
    peekWidth: 12,
    className: 'all-y-margin-three',
    itemsVisible: {
      sm: 1,
      md: 2,
      lg: 2
    },
    buttonText: {
      nextButton: l10n.formatText('carousel.nextItem'),
      prevButton: l10n.formatText('carousel.previousItem')
    }
  };

  React.useEffect(() => {
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent('.PropertyTypeCarousel.Rendered', 'Showing property type carousel module', analytics.omnitureData);
    }
  }, []);

  return (
    <>
      <h2 className="uitk-type-500 all-t-margin-three">{model.title}</h2>
      <UitkCarousel {...carouselProps}>
        {model.options.map((propertyType, index) => (
          <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED} key={index}>
            <UitkCardLink>
              <LinkTracked
                to={propertyType.linkHref}
                linkName={`VacationRentalCarousel - ${propertyType.primaryHeading}`}
                rfrr={`VacationRentalCarousel.${propertyType.name}`}
                replace={true}
              >
                {propertyType.primaryHeading}
              </LinkTracked>
            </UitkCardLink>
            <UitkCardMedia>
              <UitkFigure>
                <UitkImage src={propertyType.imageUrl} alt={propertyType.primaryHeading} />
              </UitkFigure>
            </UitkCardMedia>
            <UitkCardContent>
              <UitkCardTextSegment>
                <h3>{propertyType.primaryHeading}</h3>
                <span className="uitk-type-200 pwa-theme--grey-700">{propertyType.description}</span>
              </UitkCardTextSegment>
            </UitkCardContent>
          </UitkCard>
        ))}
      </UitkCarousel>
    </>
  );
}) as LocalizedComponentClass<PropertyTypeCarouselProps>;

const PropertyTypeCarousel = inject('analytics')(propertyTypeCarousel) as React.ComponentType<PropertyTypeCarouselProps>;

export const PropertyTypeCarouselWrapper: React.FunctionComponent<PropertyTypeCarouselPropsWithClassName> = ({ className, model }) => (
  <li className={className}>
    <PropertyTypeCarousel model={model} />
  </li>
);
